'use client';

import { FC, useEffect } from 'react';
import { BlogRecentQuery, CommunityInfoQuery, LandingQuery } from 'generated/operations';
import {
  Benefits,
  BlogPosts,
  CallToAction,
  HeroSection,
  LandingFooter,
  LandingHeader,
  Members,
  Requirements
} from 'components/landing';
import { useCommunityLandingPageTracking } from 'app/_tracking/events';

interface ILandingPage {
  communityInfo: CommunityInfoQuery['communityInfo'];
  landingData: LandingQuery['landing'];
  blog?: BlogRecentQuery;
}

export const LandingPage: FC<ILandingPage> = (props) => {
  const {
    communityInfo,
    landingData,
    blog,
  } = props;

  const { trackCommunityLandingPage } = useCommunityLandingPageTracking();

  useEffect(() => {
    trackCommunityLandingPage();
  }, []);

  const benefits: string[] = [
    landingData.benefits?.item1 ?? '',
    landingData.benefits?.item2 ?? '',
    landingData.benefits?.item3 ?? '',
    landingData.benefits?.item4 ?? '',
    landingData.benefits?.item5 ?? '',
    landingData.benefits?.item6 ?? ''
  ].filter(item => !!item);

  return (
    <div className="overflow-hidden">
      <>
        <LandingHeader
          name={communityInfo?.name ?? ''}
          logo={communityInfo?.logo ?? ''}
          secondaryUrl={landingData.headerSecondaryUrl}
          headerSecondaryUrlTitle={landingData.headerSecondaryUrlTitle}
        />
        <HeroSection landingData={landingData} connectedApp={communityInfo?.app ?? ''} />
        {!!(landingData.benefits?.title || landingData.benefits?.description || benefits.length) && (
          <Benefits
            title={landingData.benefits?.title ?? ''}
            description={landingData.benefits?.description ?? ''}
            benefits={benefits}
          />
        )}
        {!!landingData.members.length && (
          <Members members={landingData.members} />
        )}
        {!!blog?.blogRecent?.length && (
          <BlogPosts blogData={blog} />
        )}
        {!!(landingData.requirements.title || landingData.requirements.content) && (
          <Requirements title={landingData.requirements.title ?? ''}
                        content={landingData.requirements.content ?? ''} />
        )}
        {!!(landingData.cta.title || landingData.cta.buttonText) && (
          <CallToAction title={landingData.cta.title ?? ''}
                        buttonText={landingData.cta.buttonText ?? ''} />
        )}
        <LandingFooter />
      </>
    </div>
  )
}
